import * as Yup from "yup";

export const proposlSchema = (city) => Yup.object({
    fullName: Yup.string().trim()
        .min(2,'Please enter valid name')
        .max(50)
        /*.test(
            "full-name",
            function (value) {
                if (!value) {
                    return false;
                }
                const names = value.trim().split(" ");
                return names.length >= 2;
            }
        )*/
        .required("Please enter your full name"),
    panNo: Yup.string()
        .min(10, "Please enter a valid PAN number")
        .required("Please enter PAN number"),
    pin: Yup.string()
        .matches(/^(?!([0-9])\1{5})\d{6}$/, "Please enter valid PIN code").test("pin-required", "Please enter valid PIN code", function (value) {
            if (!city?.trim()) {
                return false; // If city is empty, pin must be filled
            }
            return true;
        })
        .required("Please enter PIN code"),
    nomineeName: Yup.string().trim()
        .min(2, "Please enter valid nominee name")
        .max(50)
        .required("Please enter name of the nominee"),

    occupation: Yup.string().test("occupation", "if occupation is housewife, marital status should be other than single", (value, { parent }) => {
        if (!value)
            return false;
        const occupation = value.trim();
        const { maritalStatus } = parent;
        if (occupation.toLowerCase().match("housewife") && (maritalStatus ?? "").toLowerCase() === "s")
            return false;
        return true;
    }).required("Please choose occupation"),
    education: Yup.string().required("Please choose education"),
    maritalStatus: Yup.string().test("maritalstatus", "if occupation is housewife, marital status should be other than single", (value, { parent }) => {
        if (!value)
            return false;
        const maritalStatus = value.trim();
        const { occupation } = parent;

        if ((occupation ?? "").toLowerCase().match("housewife") && maritalStatus.toLowerCase() === "s")
            return false
        return true;
    }).required("Please choose marital status"),
    /*maritalStatus: Yup.object().shape({
    label: Yup.string().required("please select any option"),
    value: Yup.string().required("please select any option")
    }),*/
    nomineeRelation: Yup.string().required("Please choose nominee relation"),
    insurerAge: Yup.number(),



    nomineeAge: Yup.number()
        .min(1, "Nominee age must be 1 or more")
        .required("Please enter nominee age")
        .test(
            "nomineeAge",
            "Please mention correct age of the nominee",
            function (value, { parent }) {
                if (
                    parent.nomineeRelation === "43~Father~Parents" ||
                    parent.nomineeRelation === "43~Mother~Parents"
                ) {

                    return value > (parent.insurerAge ?? 0) + 18;
                } else if (
                    parent.nomineeRelation === "45~Grand Father~Grandparents" ||
                    parent.nomineeRelation === "45~Grand Mother~Grandparents"
                ) {
                    return value > parent.insurerAge + 36;
                } else if (parent.nomineeRelation === "41~Spouse~Spouse") {
                    return value >= 21;
                }

                return true;
            }
        ),

    address: Yup.string()
        .min(6, "Address must contain 6 characters")
        .required("Please enter address"),
});
